import {ModalProgrammatic as Modal, DialogProgrammatic as Dialog} from 'buefy';
import EditProduct from './components/editProduct';
import database from '@/services/database';
import functions from "@/services/functions";
import storage from "@/services/storage";

const productThumbs = [
    {
        name: 'large',
        width: 800,
        height: null
    },
    {
        name: 'small',
        width: 100,
        height: 100
    }
];

function openProductModal(props, callback = null) {
    const modal = Modal.open({
        canCancel: ["escape", "x"],
        component: EditProduct,
        events: {
            onSave(product) {
                modal.close();
                if (callback) {
                    callback(product);
                }
            }
        },
        props
    })
}

export function create(setData = {}, callback = null) {
    openProductModal({setData}, callback);
}

export function edit(id, callback = null) {
    openProductModal({id, action: 'edit'}, callback);
}

export function duplicate(id, callback = null) {
    openProductModal({id, action: 'duplicate'}, callback);
}


/**
 *
 * @param {string} id
 * @param {Function} callback
 */
export function remove(id, callback = null) {
    Dialog.confirm({
        type: 'is-danger',
        title: 'Apagar produto?',
        message: 'Cuidado esta ação é irreversível',
        confirmText: 'Apagar',
        cancelText: 'Cancelar',
        async onConfirm() {
            try {
                const product = await database.collection('products').doc(id).get();
                const productData = product.data();
                if (productData.image && productData.image.id && productData.image.path && productData.image.thumbs) {
                    await removeProductImages(productData.image.id, productData.image.path, productData.image.thumbs);
                }
                await database.collection('products').doc(id).delete();
                if (callback) {
                    callback(id)
                }
            } catch (e) {
                console.error(e);
            }
        }
    });
}

/**
 * Apagar as fotos de um produto
 * @param {string} fileId
 * @param {string} originalPath
 * @param {{}} thumbs
 */
export async function removeProductImages(fileId, originalPath, thumbs) {

    const storageRef = storage.ref('products');
    const fileExtension = originalPath.split('.').pop();

    const originalRef = storageRef.child(originalPath);
    await originalRef.delete();
    
    const removePromisses = Object.keys(thumbs).map((name) => {
        const path = getThumbFilename(fileId, fileExtension, name);
        const fileRef = storageRef.child(path);
        return fileRef.delete();
    });

    return await Promise.all(removePromisses);

}

/**
 *
 * @param {string} fileId
 * @param {string} fileExtension
 * @param {string} thumb
 * @return {string}
 */
function getThumbFilename(fileId, fileExtension, thumb) {
    return `${fileId}/thumb-${thumb}.${fileExtension}`;
}

/**
 *
 * @param {string} fileId
 * @param {string} fileExtension
 * @param {string} fileType
 * @return {Promise<{}>}
 */
export async function generateProductThumbs(fileId, fileExtension, fileType) {
    const thumbs = {};
    const resizes = productThumbs.map((thumb) => {
        return resizeProductImage({
            fileId,
            extension: fileExtension,
            contentType: fileType,
            name: thumb.name,
            width: thumb.width,
            height: thumb.height
        })
    });

    const storageRef = storage.ref('products');
    const resizeReturns = await Promise.all(resizes);
    for (let i = 0; i < resizeReturns.length; i++) {
        let resized = resizeReturns[i].data;
        let thumbPath = getThumbFilename(fileId, fileExtension, resized.name);
        let ref = storageRef.child(thumbPath);
        thumbs[resized.name] = await ref.getDownloadURL();
    }

    return thumbs;
}

/**
 *
 * @param {{fileId: string, extension: string, contentType: string, name: string, width: number, height: number}} data
 * @return {Promise<firebase.functions.HttpsCallableResult>}
 */
export function resizeProductImage(data) {
    const resizeImageFn = functions.httpsCallable('resizeImage');
    return resizeImageFn(data);
}